<!--
    描述：材料组合添加页面
    时间：2020-07-13
    Created by ws
-->
<template>
	<div class="add-groups-main">
		<div class="add-groups-top">
			<w-split v-model="split">
				<div slot="left"
					 class="h100 pdr5">
					<h3 class="title text-overflow">材料分类</h3>
					<el-tree :data="materialsTree"
							 :props="defaultProps"
							 node-key="value"
							 ref="leftTree"
							 @node-click="handleNodeClick"></el-tree>
				</div>

				<div slot="right"
					 class="w-table-layout pdl10">
					<div class="w-table-content">
						<el-table :data="tableObj.tableData"
								  highlight-current-row
								  v-loading="loading"
								  stripe
								  border
								  height="480">
							<el-table-column type="index"
											 label="序号"
											 width="70"
											 align="center"></el-table-column>
							<el-table-column label="材料编码"
											 align="center"
											 prop="code"
											 show-overflow-tooltip
											 min-width="100"></el-table-column>
							<el-table-column label="材料分类"
											 align="center"
											 prop="typeName"
											 show-overflow-tooltip
											 min-width="110"></el-table-column>
							<el-table-column label="名称"
											 show-overflow-tooltip
											 prop="sname"
											 header-align="center"
											 min-width="120"></el-table-column>
							<el-table-column label="规格 / 型号"
											 show-overflow-tooltip
											 prop="specification"
											 header-align="center"
											 min-width="100"></el-table-column>
							<el-table-column label="单位"
											 show-overflow-tooltip
											 prop="unitName"
											 align="center"
											 width="100"></el-table-column>
							<el-table-column label="选择"
											 align="center"
											 width="70">
								<template slot-scope="scope">
									<el-checkbox v-model="scope.row.isChecked"
												 @change="scope.row.weight = ''"></el-checkbox>
								</template>
							</el-table-column>
							<el-table-column label="权重 (%)"
											 align="center"
											 width="120">
								<template slot-scope="scope">
									<el-input-number :disabled="!scope.row.isChecked"
													 controls-position="right"
													 :min="0"
													 :max="100"
													 v-model="scope.row.weight"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</w-split>
		</div>

		<!-- 下方名称  -->
		<div class="add-groups-bottom">
			<el-form label-width="120px"
					 :model="addForm"
					 ref="addForm"
					 :show-message="false"
					 :rules="addRules">
				<el-row :gutter="30">
					<el-col :span="8">
						<el-form-item label="组合名称："
									  prop="sname">
							<el-input placeholder="请输入组合名称"
									  v-model="addForm.sname"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="当前组合权重：">
							<el-input placeholder="总权重"
									  disabled
									  :value="totalWeight"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="当前组合单位：">
							<el-input placeholder="注意单位是否一致"
									  disabled
									  :value="totalUnit"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
import {
	getMaterialsByType,
	saveResourceCombination
} from '@/api/modules/resource.js'
import { mapState } from 'vuex'
export default {
	props: {
		// 编辑时会有的 组合ID
		combinationId: {
			type: String,
			default: ''
        },
        // 当前组合名称
        groupName: {
            type: String,
			default: ''
        }
	},
	data() {
		return {
			split: 0.3,
			materialsTree: [],
			// 树结构配置
			defaultProps: {
				children: 'children',
				label: 'sname'
			},
			currentName: '', // 当前材料名称
			currentType: '', // 当前材料分类
			tableObj: {
				tableData: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			addForm: {
				sname: '',
				unit: ''
			},
			addRules: {
				sname: [{ required: true }]
			},
			loading: false
		}
	},
	created() {
		if (this.clfl.length > 0) {
			this.materialsTree.push(...this.clfl)

			// 默认加载第一个
			this.currentType = this.materialsTree[0].value
			this.doSearch()
        }
		
		// 如果是编辑回显
		if (this.combinationId !== '') {
			this.addForm.sname = this.groupName
		}
	},
	mounted() {
		this.$nextTick(() => {
			// console.log(this.materialsTree[0])
			this.$refs.leftTree.setCurrentNode(this.materialsTree[0])
		})
	},
	methods: {
		// 左侧材料节点 点击
		handleNodeClick(node, data) {
			this.currentType = node.value

			this.doSearch()
		},

		// 查询函数
		doSearch() {
			this.loading = true
			this.tableObj.tableData = []

			// 调取接口
			getMaterialsByType({
				type: this.currentType,
				combinationId: this.combinationId
			})
				.then(res => {
					this.loading = false
					this.tableObj.tableData = res.data
				})
				.catch(err => {
					this.loading = false
				})
		},

		// 确定函数
		doSubmit() {
			// console.log(this.tableObj.tableData)
			let data = this.tableObj.tableData.filter(x => x.isChecked)

			// 判断是否选择了 组合
			if (data.length === 0) {
				this.$message.warning('请先选择组合材料！')
				this.$emit('on-error')
				return
			}

			// 判断单位是否统一
			if (!this.isSampleUnit) {
				this.$message.warning('当前所选材料单位不一致，请重新选择!')
				this.$emit('on-error')
				return
			}

			// 判断权重是否为 100%
			if (this.totalWeight !== 100) {
				this.$message.warning('当前所选材料权重不为100，请重新配置!')
				this.$emit('on-error')
				return
            }
            
            data.map(x => {
                x.resourceId = x.id
                delete x.id
            })

			let params = {
				type: 1,
				sname: this.addForm.sname,
				unit: this.totalUnit,
				resourceType: this.currentType,
				combinationRelates: data
            }
            
            this.combinationId !== '' ? params.id = this.combinationId : ''

			this.$refs.addForm.validate(valid => {
				if (valid) {
					// 再判断
                    saveResourceCombination(params)
                        .then(res => {
                            this.$message.success('保存成功!')
                            this.$emit('on-success')
                        })
                        .catch(err => {
                            this.$emit('on-error')
                        })
				} else {
					this.$message.warning('请输入组合名称!')
					this.$emit('on-error')
					return
				}
			})
		}
	},
	computed: {
		...mapState('dict', {
			clfl: state => state.clfl
		}),

		// 总权重
		totalWeight() {
			let arr = this.tableObj.tableData.filter(x => x.isChecked)

			let total = 0
			arr.map(x => {
				let _number = parseFloat(x.weight) || 0
				total += _number
			})

			return total
		},

		// 组合单位是否统一
		totalUnit() {
			let arr = this.tableObj.tableData.filter(x => x.isChecked)

			let unitArr = []
			arr.map(x => {
				unitArr.push(x.unitName)
			})

			// 单位数组去重
			let _unit = ''
			let resArr = Array.from(new Set(unitArr))
			// 单位相同 数量为1
			if (resArr.length === 1) {
				_unit = resArr[0]
				this.isSampleUnit = true
			} else {
				_unit = '单位不一致 或 未选择材料'
				this.isSampleUnit = false
			}

			return _unit
		}
	}
}
</script>

<style scoped lang="less">
.add-groups-main {
	height: 530px;

	.add-groups-top {
		height: 480px;
	}

	.add-groups-bottom {
		padding: 5px 0;
		height: 50px;
		line-height: 50px;
		overflow: hidden;
	}

	.title {
		height: 32px;
		line-height: 32px;
		color: #303133;
		font-size: 16px;
	}

	.w-table-layout {
		background-color: #fff;
	}

	/deep/ .el-tree-node__content {
		height: 28px;
		line-height: 28px;
	}

	/deep/ .el-tree-node__content:hover {
		background-color: #039be5;
		color: #fff;
	}

	/deep/ .is-current {
		.el-tree-node__content {
			background-color: #039be5;
			color: #fff;
		}
	}

	/deep/ .el-input-number {
		width: 100%;
		line-height: 30px;

		span {
			line-height: 15px;
		}

		.el-input__inner {
			height: 32px;
			line-height: 32px;
		}
	}
}
</style>
